import type { ActionReducerMapBuilder, PayloadAction } from '@reduxjs/toolkit';
import getUsersFilterOptions from 'src/redux/filter/api';
import type { InitialFilterStateType } from 'src/redux/filter/types';

const extraReducers = (builder: ActionReducerMapBuilder<InitialFilterStateType>) => {
  // users list page filter options
  builder.addCase(getUsersFilterOptions().pending, (state: InitialFilterStateType) => {
    state.usersListFilter.isLoading = true;
  });
  builder.addCase(
    getUsersFilterOptions().fulfilled,
    (
      state: InitialFilterStateType,
      action: PayloadAction<InitialFilterStateType['usersListFilter']['filterOptions']>,
    ) => {
      state.usersListFilter.isLoading = false;
      state.usersListFilter.filterOptions = action?.payload;
    },
  );
  builder.addCase(getUsersFilterOptions().rejected, (state: InitialFilterStateType) => {
    state.usersListFilter.isLoading = false;
  });
};

export default extraReducers;
